import { throwError } from "@/lib/throwError";
import { del, get } from "@/services/axiosUitils";
import {
  ImportListResponse,
  ImportListResponsePaginated,
} from "@/utils/types/importManagement";

class ImportManagementService {
  getImportList = async (
    page: number = 1,
    pageSize: number = 10
  ): Promise<ImportListResponse> => {
    return await get<ImportListResponse>(
      `/api/import-data/?page=${page}&page_size=${pageSize}`
    );
  };

  getImportDetail = async (
    importId: string
  ): Promise<ImportListResponsePaginated> => {
    if (!importId) {
      throwError("Import ID is required", "ImportManagementService");
    }
    return await get<ImportListResponsePaginated>(
      `/api/import-data-by-id/${importId}/`
    );
  };

  getImportsBySchema = async (
    schemaName: string,
    page: number = 1,
    pageSize: number = 10
  ): Promise<ImportListResponse> => {
    if (!schemaName) {
      throwError("Schema name is required", "ImportManagementService");
    }
    return await get<ImportListResponse>(
      `/api/import-data/?schema_name=${schemaName}&page=${page}&page_size=${pageSize}`
    );
  };

  getImportsByStatus = async (
    status: string,
    page: number = 1,
    pageSize: number = 10
  ): Promise<ImportListResponse> => {
    if (!status) {
      throwError("Status is required", "ImportManagementService");
    }
    return await get<ImportListResponse>(
      `/api/import-data/?status=${status}&page=${page}&page_size=${pageSize}`
    );
  };

  deleteImportRecord = async (id: string): Promise<void> => {
    return await del<void>(`/api/import-data/record/${id}/`);
  };
}

const instance = new ImportManagementService();
export default instance;
